import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InputField from './InputField';
import { post } from '../Services/http';
import { receive as receiveOwned } from '../Actions/UserOwnedFullLicenseProducts.action';
import { receive as receiveDemo } from '../Actions/UserOwnedFullLicenseProducts.action';
import OpenSoftubeCentral from './OpenSoftubeCentral';
import { addFlashMessage } from '../Actions/FlashMessages.action';

const SoftwareLicenseDirectDepositModal = ({modalId}) => {
    const dispatch = useDispatch();
    const softwareLicenseDirectDepositModal = useSelector((state) => state.softwareLicenseDirectDepositModal);
    const [showConfirm, setShowConfirm] = useState(false);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [depositing, setDepositing] = useState(false);

    const depositLicense = () => {
        if (!depositing) {
            setDepositing(true);

            let productArticleNumber = softwareLicenseDirectDepositModal.productArticleNumber;

            if (softwareLicenseDirectDepositModal.type === 0) {
                // SoftwareLicenseDirectDepositModalType.Demo
                post('/api/products/depositdemolicense/' + productArticleNumber)
                    .then((response) => response.json())
                    .then((userDemoedLicenseProducts) => {
                        dispatch(receiveDemo(userDemoedLicenseProducts));
                        setShowConfirm(true);
                    })
                    .catch(() => {
                        document.querySelector(modalId).close(); 
                        enableBodyScroll();
                        dispatch(addFlashMessage({ messageText: softwareLicenseDirectDepositModal.errorText, messageType: "Pink", dismissible: true, timeToLive: 10 }));
                        setDepositing(false);
                    });
            } else {
                // SoftwareLicenseDirectDepositModalType.Free
                post('/api/products/depositfreelicense/' + productArticleNumber)
                    .then((response) => response.json())
                    .then((userOwnedFullLicenseProducts) => {
                        dispatch(receiveOwned(userOwnedFullLicenseProducts));
                        setShowConfirm(true);
                    })
                    .catch(() => {
                        document.querySelector(modalId).close(); 
                        enableBodyScroll();
                        dispatch(addFlashMessage({ messageText: softwareLicenseDirectDepositModal.errorText, messageType: "Pink", dismissible: true, timeToLive: 10 }));
                        setDepositing(false);
                    });
            }
        }
    }

    return (
        <Fragment>
            {showConfirm ? (
                <Fragment>
                    <div className="software-license-direct-deposit-modal__content software-license-direct-deposit-modal__content--success">
                        <i className="icon-check_circle"></i>
                        <div dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.successText} } />
                    </div>
                    <OpenSoftubeCentral downloadMacUrl={softwareLicenseDirectDepositModal.softubeCentralLinks.macUrl} downloadWindowsUrl={softwareLicenseDirectDepositModal.softubeCentralLinks.windowsUrl} />
                </Fragment>
            ) : (
                <Fragment>
                    <div className="software-license-direct-deposit-modal__head" >
                        <h5 dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.headTitle} } />
                    </div>
                    <div className="software-license-direct-deposit-modal__content">
                        {!softwareLicenseDirectDepositModal.isSignedIn ? (
                            <Fragment>
                                <h4 dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.signinTitle} } />
                                <span dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.signinText} } />
                                <div>
                                    <a href={softwareLicenseDirectDepositModal.signInUrl} className="button">
                                        {softwareLicenseDirectDepositModal.signinButtonText}
                                    </a>
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                {!softwareLicenseDirectDepositModal.hasIlokId ? (
                                    <Fragment>
                                        <h4 dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.linkILokTitle} } />
                                        <span dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.linkILokText} } />
                                        <div>
                                            <a href={softwareLicenseDirectDepositModal.signInUrl} className="button">
                                                {softwareLicenseDirectDepositModal.linkILokButtonText}
                                            </a>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <h4 dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.confirmTitle} } />
                                        <span dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.confirmText} } />
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </div>
                    {(softwareLicenseDirectDepositModal.isSignedIn && softwareLicenseDirectDepositModal.hasIlokId) &&
                        <div className="software-license-direct-deposit-modal__footer">
                            <div className="software-license-direct-deposit-modal__footer__terms-and-conditions">
                                <div dangerouslySetInnerHTML={ {__html: softwareLicenseDirectDepositModal.acceptTermsText.value} } />
                                <form>
                                    <InputField
                                        id='acceptTerms'
                                        name='acceptTerms'
                                        type='checkbox'
                                        value='acceptTerms'
                                        checked={acceptTerms}
                                        disabled={depositing}
                                        label={softwareLicenseDirectDepositModal.acceptTermsCheckboxText}
                                        onChange={(value) => setAcceptTerms(value)}
                                        containerCssClass='label-checkbox'
                                        labelCssClass='label-checkbox__text'
                                    />
                                </form>
                            </div>
                            <div>
                                <button className={`button button--full-width ${depositing ? "loading" : ""}`} onClick={() => depositLicense()} disabled={depositing || !acceptTerms}>
                                    <i className="icon-download"></i>
                                    <span>{softwareLicenseDirectDepositModal.confirmButtonText}</span>
                                    <span className="spinner spinner--light spinner--small"></span>
                                </button>
                            </div>
                        </div>
                    }
                </Fragment>
            )}
        </Fragment>
    );
};

export default SoftwareLicenseDirectDepositModal;
